import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { Button } from '@material-ui/core';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import useKeyBindings from 'src/modules/shared/hooks/useKeyBindings';

const AppInfo = () => {
  const [infoModal, showInfoModal] = useState(false);

  useKeyBindings({
    'Control+Shift+K': (event) => {
      console.log('Control+Shift+K pressed');
    },
  });

  if (!infoModal) {
    return null;
  }

  return (
    <Dialog open={infoModal} onClose={() => showInfoModal(false)}>
      <DialogTitle>Frontend Application Info</DialogTitle>
      <DialogContent>
        <Typography>Version: {process.env.REACT_APP_VERSION}</Typography>
        <Typography>
          Build date:{' '}
          {format(parseISO(process.env.REACT_APP_BUILD_TIME as string), 'dd/MM/yyyy HH:mm')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          startIcon={<FontAwesomeSpriteIcon icon={SpriteIconsLight.CANCEL} color="white" />}
          onClick={() => showInfoModal(false)}
        >
          {'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppInfo;
